/** Copyright © 2024 Qcells. All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized use,
 * duplication, or distribution of software is strictly prohibited.
 */
import '@hems/component/resources/vendor/css_new/common.css';
import '@hems/component/resources/vendor/css_new/common_style.css';
import '@hems/component/resources/vendor/css_new/main.css';
import '@hems/component/resources/vendor/css_new/contents.css';
import '@hems/component/resources/vendor/css_new2021/common_new2021.css';
import '@hems/component/resources/styles/main.scss';
import 'vue-final-modal/dist/style.css';

import { createApp } from 'vue';
import { createVfm } from 'vue-final-modal';

import PrimeVue from 'primevue/config';

import App from '@hems/portal/src/App.vue';
import router from '@hems/portal/src/router';
import store from '@hems/portal/src/store';
import { AxiosPlugin, i18n, initYup } from '@hems/util';

initYup();

const vueFinalModal = createVfm();

const startMSW = async () => {
  if (process.env.VUE_APP_USE_MOCK === 'true') {
    const { worker } = await import('@hems/util/src/mocks/browser');

    worker.start({
      onUnhandledRequest: 'bypass',
    });
  }
};

startMSW();

createApp(App)
  .use(AxiosPlugin, {
    baseURL: process.env.VUE_APP_API_URL,
  })
  .use(store)
  .use(i18n)
  .use(router)
  .use(vueFinalModal)
  .use(PrimeVue, { unstyled: true })
  .mount('#app');
